import axios from 'axios';
import Token from 'utils/Token';
import interfaceBridge from './interfaceBridge';
import Config from 'config/Config';
import { DO_REFRESH_ACCESS_TOKEN } from 'network/shared/user';
import { RefreshAccessTokenRequestT } from 'types/shared/reqAndRes/Token';
import { TokenObjT } from 'types/shared/core/Token';
import { MyResponse } from 'types/shared/reqAndRes/MyResponse';
import ObservableVariable from './ObservableVariable';

export type AccessTokenStateT = 'NORMAL' | 'REFRESHING' | 'ERROR';

class AccessTokenManager {
  accessTokenState = new ObservableVariable<AccessTokenStateT>('NORMAL');
  count = 0;

  // accessToken 이 갱신되면 실행할 콜백의 집합
  observers: ((at: string) => void)[] = [];

  refreshAccessToken = async (): Promise<string> => {
    if (this.accessTokenState.value === 'ERROR') {
      return '';
    }

    console.log('refreshing AccessToken');
    this.accessTokenState.value = 'REFRESHING';
    this.count++;

    const refreshToken = Token.getToken('refreshToken');
    if (!refreshToken) {
      console.log('refreshToken 얻지 못함');
      this.accessTokenState.value = 'ERROR';
      return '';
    }

    const deviceName = interfaceBridge.deviceInfo('deviceName');

    console.log(
      'AccessTokenManager accessToken을 다시 받는 중입니다.',
      this.count,
    );
    console.log('AccessTokenManager refreshToken', refreshToken);
    console.log(
      'AccessTokenManager url',
      Config.apiBaseUrl + DO_REFRESH_ACCESS_TOKEN.path,
    );

    const refreshAccessTokenRequest: RefreshAccessTokenRequestT = {
      refreshToken,
      deviceName,
    };
    try {
      const result = await axios.post<MyResponse<TokenObjT>>(
        `${Config.apiBaseUrl}${DO_REFRESH_ACCESS_TOKEN.path}`,
        refreshAccessTokenRequest,
        {
          // 서버에서 accessToken을 재발급받는데 cookie가 필요함
          withCredentials: true,
        },
      );

      let newAccessToken = '';
      if (
        result.status === 200 &&
        result.data.isSuccess &&
        result.data.object?.accessToken
      ) {
        console.log(
          'AccessTokenManager 새 accessToken을 발급받았습니다.',
          result.data.object.accessToken,
        );

        newAccessToken = result.data.object.accessToken;

        interfaceBridge.saveToken(
          result.data.object.userId,
          result.data.object,
        );
      }

      if (!newAccessToken) {
        this.accessTokenState.value = 'ERROR';
        throw new Error('error getting access token');
      }

      // 쌓여있는 callback도 수행 필요
      this.accessTokenState.value = 'NORMAL';
      this.observers.forEach((cb) => cb(newAccessToken));
      this.observers.length = 0;
      return newAccessToken;
      //
    } catch (e: unknown) {
      console.log('AccessTokenManager refresh token error : ', e);
      this.accessTokenState.value = 'ERROR';
      throw e;
    }
  }; // end of refreshAccessToken

  getNewAccessToken = (): Promise<string> => {
    if (this.accessTokenState.value === 'REFRESHING') {
      // 남이 요청해 두었음, 결과값만 받으면 됨
      console.log(
        'AccessTokenManager 남이 요청해 두었음, 결과값만 받으면 됨',
        this.count,
      );

      return new Promise((resolve) => {
        this.observers.push((at) => {
          console.log('AccessTokenManager 남이 요청한거 결과 나옴', at);
          resolve(at);
        });
      });
    }

    return this.refreshAccessToken();
  };
}

export default new AccessTokenManager();
